// Polyfills for Chrome 87 support

// Core-js stable adds missing ES features (Array.from, Object.assign, Promise, etc.)
import 'core-js/stable';

// Regenerator runtime adds support for async/await
import 'regenerator-runtime/runtime';

// Optional: add any global missing APIs manually if needed
// Example: Object.hasOwn (introduced in ES2022)
if (!Object.hasOwn) {
    Object.hasOwn = function (obj: object, prop: PropertyKey): boolean {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    };
}